import { Flex, Button } from '@cad-arc';
import { Mark43File } from '@mark43/cad-api';
import { downloadFile } from '../common/helpers/downloads';
import { ResultImage } from './results/result-image';
import { useEnabledFeatures } from '~/common/hooks/enabled-features';

export function ResultImageLine({ mark43File }: { mark43File: Mark43File }): React.ReactElement {
    const { mediaAttachmentsEnabled } = useEnabledFeatures();
    return (
        <Flex w="100%" justifyContent="space-between">
            <ResultImage mark43FilePath={mark43File.fileResourcePath} />
            <Button
                as="a"
                trailingVisual="Download"
                variant="ghost"
                onClick={() => downloadFile(mark43File, mediaAttachmentsEnabled)}
                download
                aria-label="download"
            >
                Download Photo
            </Button>
        </Flex>
    );
}
